// Influencer pages

export function InfluencerDashboardPage() {
    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold">Dashboard do Influenciador</h1>
            <p className="text-gray-500">Painel de afiliados em desenvolvimento...</p>
        </div>
    );
}
